import React from 'react';
import { useTranslation } from "react-i18next";
import { useVisaRegister } from './zustand';
import clsx from 'clsx';

const Step = () => {
  const { t } = useTranslation()


  const { selectedVisa, step, currentVisaSteps } = useVisaRegister()


  const isCreateVisaStepPassed = step=='SELECT_VISA' ||  currentVisaSteps?.length > 1

  const isStepPass = (targetStep:typeof step) => step!='SELECT_VISA' && currentVisaSteps.findIndex(i=>i==step) >=  currentVisaSteps.findIndex(i=>i==targetStep)

  console.log({currentVisaSteps})

  return (
    <div className={clsx(`flex justify-center max-w-[750px] mx-auto mb-4 md:mb-0`, !selectedVisa?.id && '[&>.depended-step]:blur-sm')}>
      <div className={"flex  items-start w-1/5 justify-center md:justify-end relative "}>
        <div className={"flex flex-col items-center md:min-w-[90px]"}>
          <div className={`border-2 ${isCreateVisaStepPassed ? "border-primary-800" : "border-secondary-700"} flex items-center justify-center w-8 h-8 rounded-full`}>
            <div className={`${isCreateVisaStepPassed ? "bg-primary-800" : "bg-secondary-700"} w-3 h-3 rounded-full`} />
          </div>
          <span className={` text-[10px] text-center md:text-sm mt-2  ${isCreateVisaStepPassed ? "text-primary-800" : "text-secondary-700"} `}>
            {t("stepOne")}
          </span>
        </div>
        <div className={`absolute md:relative right-[75%] md:right-0 border-b-2  ${false ? "border-primary-800" : "border-secondary-700"} border-dashed w-[45%] md:w-1/2 h-4 depended-step`} />
      </div>

      <div className={clsx("flex  items-start w-1/5 justify-center relative ", selectedVisa && selectedVisa?.need_dock_and_ships ? '' : 'hidden')}>
        <div className={"flex flex-col items-center  md:min-w-[90px]"}>
          <div className={`border-2 ${isStepPass('DOCK_SHIP') ? "border-primary-800" : "border-secondary-700"} flex items-center justify-center w-8 h-8 rounded-full`}>
            <div className={`${isStepPass('DOCK_SHIP') ? "bg-primary-800" : "bg-secondary-700"} w-3 h-3 rounded-full`} />
          </div>
          <span className={`text-[10px] text-center md:text-sm mt-2  ${isStepPass('DOCK_SHIP') ? "text-primary-800" : "text-secondary-700"} `}>
            {t("stepTwo")}
          </span>
        </div>
        <div className={`absolute md:relative right-[80%] md:right-0 border-b-2 ${isStepPass('DOCK_SHIP') ? "border-primary-800" : "border-secondary-700"} border-dashed w-[45%] md:w-1/2 h-4`} />
      </div>


      <div className={clsx("flex  items-start w-1/5 justify-center md:justify-start relative depended-step", selectedVisa && selectedVisa?.need_fly ? '' : 'hidden')}>
        <div className={"flex flex-col items-center  md:min-w-[90px]"}>
          <div className={`border-2 ${isStepPass('FLIGHT') ? "border-primary-800" : "border-secondary-700"} flex items-center justify-center w-8 h-8 rounded-full`}>
            <div className={`${isStepPass('FLIGHT') ? "bg-primary-800" : "bg-secondary-700"} w-3 h-3 rounded-full`} />
          </div>
          <span className={`text-[11px] text-center md:text-sm mt-2  ${isStepPass('FLIGHT') ? "text-primary-800" : "text-secondary-700"} `}>
            {t("stepThree")}
          </span>
        </div>
        <div className={`absolute md:relative right-[78%] md:right-0 border-b-2 ${isStepPass('UPLOAD_DOCS') ? "border-primary-800" : "border-secondary-700"} border-dashed w-[45%] md:w-1/2 h-4`} />
      </div>
      <div className={"flex  items-start w-1/5 justify-center md:justify-around relative depended-step"}>
        <div className={"flex flex-col items-center  min-w-[80px] "}>
          <div className={`border-2 ${isStepPass('UPLOAD_DOCS') ? "border-primary-800" : "border-secondary-700"} flex items-center justify-center w-8 h-8 rounded-full`}>
            <div className={`${isStepPass('UPLOAD_DOCS') ? "bg-primary-800" : "bg-secondary-700"} w-3 h-3 rounded-full`} />
          </div>
          <span className={`text-[10px] text-center md:text-sm mt-2  ${isStepPass('UPLOAD_DOCS') ? "text-primary-800" : "text-secondary-700"} `}>
            {t("stepFour")}
          </span>
        </div>
        <div className={`absolute md:relative right-[76%] md:right-0 border-b-2 ${isStepPass('PAY') ? "border-primary-800" : "border-secondary-700"} border-dashed w-[45%] md:w-1/2 h-4`} />
      </div>
      <div className={"flex  items-start depended-step "}>
        <div className={"flex flex-col items-center  md:min-w-[90px]"}>
          <div className={`border-2 ${isStepPass('PAY') ? "border-primary-800" : "border-secondary-700"} flex items-center justify-center w-8 h-8 rounded-full`}>
            <div className={`${isStepPass('PAY') ? "bg-primary-800" : "bg-secondary-700"} w-3 h-3 rounded-full`} />
          </div>
          <span className={`text-[10px] text-center md:text-sm mt-2  ${isStepPass('PAY') ? "text-primary-800" : "text-secondary-700"} `}>
            {t("stepFive")}
          </span>
        </div>
      </div>

    </div>
  );
};

export default Step;
